import Constants from '../../../constants/Constants';
import {fabric} from 'fabric';

const turnOnMouseEventListeners = (canvas: fabric.Canvas, setAnnotationExists: (annotationExists: boolean) => void): void => {
   let startingPoint: fabric.IPoint;

   const mouseDown = (event: any): void => {
      if (event.target) {
         return;
      }

      canvas.on('mouse:move', mouseMove);
      canvas.on('mouse:up', mouseUp);

      startingPoint = canvas.getPointer(event.e);

      const square = new fabric.Rect({
         width: 0,
         height: 0,
         left: startingPoint.x,
         top: startingPoint.y,
         stroke: canvas.freeDrawingBrush.color,
         strokeWidth: canvas.freeDrawingBrush.width,
         fill: Constants.annotation.transparentColor,
         name: Constants.annotation.shape.rect
      });

      square.setControlsVisibility({bl: true, br: true, mb: true, ml: true, mr: true, mt: true, tl: true, tr: true, mtr: false});
      canvas.add(square);
      canvas.setActiveObject(square);
      canvas.selection = false;
   };

   const mouseMove = (event: any): void => {
      const mouse = canvas.getPointer(event.e);
      const square = canvas.getActiveObject();

      const left = startingPoint.x > mouse.x ? mouse.x : startingPoint.x;
      const top = startingPoint.y > mouse.y ? mouse.y : startingPoint.y;
      const width = Math.abs(startingPoint.x - mouse.x);
      const height = Math.abs(startingPoint.y - mouse.y);

      square.set({left, top, width, height});
      canvas.requestRenderAll();
   };

   const mouseUp = (): void => {
      const square: fabric.Object = canvas.getActiveObject();

      if (square && (square.width === 0 || square.height === 0)) {
         canvas.remove(square);
      }

      canvas.discardActiveObject();
      canvas.selection = true;
      canvas.fire('object:added', {target: square});
      setAnnotationExists(true);
      canvas.requestRenderAll();

      canvas.off('mouse:move', mouseMove);
      canvas.off('mouse:up', mouseUp);
   };

   canvas.defaultCursor = 'crosshair';
   canvas.on('mouse:down', mouseDown);
};

export default {
   turnOnMouseEventListeners
};